export const fullName = (u: { firstName?: string; lastName?: string; email: string }): string =>
    `${u.firstName ?? ''} ${u.lastName ?? ''}`.trim() || u.email;
